import {FC} from "react";

const Team: FC = () => {
    return (
        <div className="Team">
            <h1>Team</h1>
            <p>Team content goes here.</p>
        </div>
    );
}

export default Team;